import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AddPhotoConstants as ui } from '../../Config/UIConstants';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { IUploadedPhoto } from '../../Stores/UserPhotoStore';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { largeShadow } from '../../styles/styleObjects';
import { AbstractAddPhotosPage } from '../AddPhotosPage/AbstractAddPhotosPage';
import { IPossibleDuplicate } from '../StoriesPage/StoryPhotoUploader';
import { OnboardingActivityIndicator, OnboardingPages } from './OnBoardingNav';
import { onboardingStyles } from './OnboardingStyles';

interface IProps extends RouteComponentProps<any> {
    store: ApplicationStore;
}

interface IState {
    images: Array<IUploadedPhoto>;
    currentImageFocusIndex: number;
    indexOfImageToUpload: number;
    showUploadProgress: boolean;
    possibleDuplicates: Array<IPossibleDuplicate>;
    duplicateIndex: number;
    errors: Array<string>;
    showUploadErrorConfirmButton: boolean;
}

@inject('store')
@observer
export class OnboardingAddPhotos extends AbstractAddPhotosPage<IProps> {
    public state: IState = {
        images: [],
        currentImageFocusIndex: 0,
        indexOfImageToUpload: 0,
        showUploadProgress: false,
        possibleDuplicates: [],
        duplicateIndex: 0,
        errors: [],
        showUploadErrorConfirmButton: false,
    };

    private onPressNext = (): void => {
        this.uploadAllImages();
    }

    protected renderEmptyPhotosHeader() {
        return null;
    }
    protected renderPhotosHeader() {
        return null;
    }
    protected renderPhotosBottomBar() {
        return null;
    }

    protected async onFinishedUploadedPhotosCallback(): Promise<void> {
        await this.props.store.onboardingStore.createStoryPrivately();
        await this.props.store.onboardingStore.addAllPhotosToStory();
        this.props.history.push(Routes.ONBOARDING_FINISHED);
    }

    private createStoryAndNavToFinish = () => {
        const storyTitle = this.props.store.onboardingStore.storyTitle;
        if (!storyTitle) {
            return;
        }
        this.props.store.storyStore.createStory(storyTitle).then(() => {
            this.props.history.push(Routes.ONBOARDING_FINISHED);
        });
    }

    public render() {
        const hasImages = this.state.images.length > 0;

        let headerContainerText: string;
        let activePageIndicator: OnboardingPages;
        if (hasImages) {
            headerContainerText = ui.STEP_THREE;
            activePageIndicator = OnboardingPages.AddPhotoMeta;
        } else {
            headerContainerText = ui.STEP_TWO;
            activePageIndicator = OnboardingPages.AddPhotos;
        }

        return (
            <FullScreenModalContainer
                justifyContent="space-between"
                alignItems="center"
                {...this.props}
                onPressExit={() => this.props.history.push(Routes.ALBUMS)}
            >
                <div style={styles.contentContainer}>
                    <p style={{
                        ...onboardingStyles.headerText,
                        ...styles.headerText,
                    } as React.CSSProperties} dangerouslySetInnerHTML={{__html: headerContainerText}}/>
                    {this.renderContent()}
                </div>
                <div style={styles.bottomContainer}>
                    {hasImages ? (
                        <CommonActionButton
                            buttonContent={ui.NEXT_BUTTON}
                            containerStyle={styles.buttonContainer}
                            fontStyle={styles.buttonText}
                            onClick={this.onPressNext}
                        />
                    ) : (
                        <div>
                            <CommonActionButton onClick={() => this.createStoryAndNavToFinish()} buttonContent={ui.SKIP_FOR_NOW} />
                        </div>
                    )}

                    <OnboardingActivityIndicator activePage={activePageIndicator}/>
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    verticalSpacer: {
        height: 48,
    },
    inputContainer: {
        width: '100%',
        height: 85,
        marginBottom: 15,
        backgroundColor: 'white',
        boxShadow: largeShadow,
    },
    inputCancel: {
        height: 30,
        width: 30,
        borderRadius: 15,
        position: 'relative',
        right: '-89%',
        bottom: 63,
        backgroundColor: '#00000022',
    } as React.CSSProperties,
    cancelIcon: {
        height: '100%',
        width: '100%',
        objectFit: 'contain',
    },
    contentContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '30%',
        flex: 1,
        flexDirection: 'column',
        pointerEvents: 'none',
    } as React.CSSProperties,
    bottomContainer: {
        height: 150,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'auto',
    } as React.CSSProperties,
    buttonText: {
        fontSize: 14,
        fontWeight: 200,
        letterSpacing: 1,
    } as React.CSSProperties,
    buttonContainer: {
        height: 48,
        width: 180,
    },
    headerText: {
        marginBottom: '1em',
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingAddPhotos.tsx